import "./mini-components.css";
import { FoodType } from "../../models/Restaurent_food_model.js";

export const FoodTypeIndicator = ({ type }) => {
  return (
    <div
      className={
        type == FoodType.NON_VEG
          ? "foodtype-container"
          : "foodtype-container foodtype-container-veg"
      }
    >
      <div
        className={
          type == FoodType.NON_VEG
            ? "foodtype-circle"
            : "foodtype-circle foodtype-circle-veg"
        }
      ></div>
    </div>
  );
};

export default FoodTypeIndicator;

export const MainTitle = ({ title }) => {
  return <div className="main-title">{title}</div>;
};

export const LoadingSpinner = ({ isBig }) => {
  return (
    <div className={isBig ? "loading-spinner-big" : "loading-spinner"}></div>
  );
};

export const WhiteSpinner = () => {
  return <div className="loading-spinner black-spinner"></div>;
};
